var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-million"},[_c('SportCallerBase',{attrs:{"url":_vm.url},on:{"redirect":_vm.handleRedirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }